import { userConstants } from '../constants';
import myFetchWithId from '../helpers/myFetch';

const dashboardApi = '/v5/lowi/profile/sd';

export function fetchDashboardList() {
  const normalFetch = myFetchWithId('', true, true);
  return dispatch => {
    dispatch(requestDashboardList())
    return normalFetch(`${dashboardApi}/gets`)
      .then(json => { dispatch(receiveDashboardList(json)) })
      .then(json => receivedStatus(json))
  }
}
function requestDashboardList() {
  return {
    type: userConstants.DASH_LIST_REQUEST,
  }
}
function receiveDashboardList(json) {
  return {
    type: userConstants.DASH_LIST_RECEIVE,
    dashboardList: json.response_status === "SUCCESS" && json.response_data ? json.response_data : [],
    receivedAt: Date.now()
  }
}

function receivedStatus(json) {
  return {status: json};
}

export function fetchDashboardWidgets(id) {
  const normalFetch = myFetchWithId('', true, true);
  return dispatch => {
    dispatch(requestDashboardWidgets())
    return normalFetch(`${dashboardApi}/get`, {id: id})
      .then(json => { dispatch(receiveDashboardWidgets(json)) })
      .then(json => receivedStatus(json))
  }
}

function requestDashboardWidgets() {
  return {
    type: userConstants.DASH_CONTENT_REQUEST,
  }
}

function receiveDashboardWidgets(json) {
  try {
    if (json.response_status === "SUCCESS" && json.response_data) {
      var widgets = json.response_data[0].widgets ? json.response_data[0].widgets.map( widget => decodeURIComponent(widget.condition_str)) : [];
      var widgetsParse = widgets.map( widget => JSON.parse(widget));
      // add the id from database into the widget information Object
      var length = json.response_data[0].widgets.length;
      var data = new Array(length);
      for (var i = 0; i < length; i++) {
        data[i] = { ...widgetsParse[i], dBId: json.response_data[0].widgets[i].id};
      };
    }
  } catch (err) {
    console.log('error @@@@@@', err);
  }
  return {
    type: userConstants.DASH_CONTENT_RECEIVE,
    dashboardWidgets: json.response_data[0].widgets ? data : [],
    receivedAt: Date.now()
  }
}



// WEBPACK FOOTER //
// ./src/actions/dashboard.actions.js